import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dashboardService from '../services/dashboardService';

function HomePage() {
  const { t, i18n } = useTranslation();

  // Check if current language is Marathi
  const isMarathi = i18n.language === 'mr';

  // WhatsApp Configuration
  const whatsappConfig = {
    phoneNumber: '919876543210', // Replace with your actual WhatsApp number
    message: 'Hello, I need assistance with my complaint.',
    qrSize: '96x96',
  };

  const [stats, setStats] = useState({
    registered: 0,
    resolved: 0,
    loading: true,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await dashboardService.getPublicStats();
        if (response.success) {
          setStats({
            registered: response.data.registered,
            resolved: response.data.resolved,
            loading: false,
          });
        } else {
          throw new Error('Failed to fetch stats');
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-100">
      {/* Gadchiroli District Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-0 pb-8">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200 px-6 py-6 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            {t('home.title') || 'Gadchiroli District'}
          </h1>
          <p
            className="text-sm sm:text-base font-medium mb-4"
            style={{ color: '#B8860B' }}
          >
            {t('home.trackcard.citizennote')}
          </p>
          {/* <p className="text-gray-600 max-w-2xl mx-auto mb-6">
            {t('home.subtitle') ||
              'Your voice matters. Report issues and track their resolution.'}
          </p>  */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <Link
              to="/complaint/new"
              className="flex-1 px-6 py-3 text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
              style={{ backgroundColor: '#B8860B' }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#DAA520')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#B8860B')}
            >
              {t('nav.newComplaint') || 'Register Complaint'}
            </Link>
            <Link
              to="/complaint/status"
              className="flex-1 px-6 py-3 border-2 font-medium rounded-lg transition-all duration-200 hover:bg-yellow-50"
              style={{ borderColor: '#B8860B', color: '#B8860B' }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#FEF3C7';
                e.target.style.borderColor = '#DAA520';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderColor = '#B8860B';
              }}
            >
              {t('nav.trackComplaint') || 'Track Complaint'}
            </Link>
          </div>
        </div>
      </div>

      {/* Complaint Statistics Section */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200 px-6 py-8">
          <div className="text-center mb-8">
            <h2
              className={`text-xl sm:text-2xl font-bold text-gray-900 ${isMarathi ? 'mb-1' : 'mb-2'}`}
            >
              {t('home.complaintStatistics')}
            </h2>
            <div
              className={`w-16 h-1 mx-auto rounded-full ${isMarathi ? 'mt-2' : ''}`}
              style={{ backgroundColor: '#B8860B' }}
            ></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="relative text-center p-8 bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl border-2 border-orange-200 shadow-lg hover:shadow-xl transition-all duration-300">
              <div
                className="absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center"
                style={{ backgroundColor: 'rgba(184, 134, 11, 0.1)' }}
              >
                <svg
                  className="w-6 h-6"
                  style={{ color: '#B8860B' }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              {stats.loading ? (
                <div className="animate-pulse">
                  <div className="h-12 bg-gray-200 rounded mb-3 mx-auto w-24"></div>
                  <div className="h-4 bg-gray-200 rounded mx-auto w-32"></div>
                </div>
              ) : (
                <>

                  <h3 className="text-4xl font-bold mb-3" style={{ color: '#B8860B' }}>
                    {stats.registered.toLocaleString() || '0'}
                  </h3>
                  <p className="text-gray-700 font-semibold text-lg">
                    {t('home.totalRegistered') || 'Total Registered'}
                  </p>
                  <p className="text-gray-600 text-sm mt-1">
                    {t('home.complaintsReceived') || 'Complaints Received'}
                  </p>
                </>
              )}
            </div>

            <div className="relative text-center p-8 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border-2 border-green-200 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              {stats.loading ? (
                <div className="animate-pulse">
                  <div className="h-12 bg-gray-200 rounded mb-3 mx-auto w-24"></div>
                  <div className="h-4 bg-gray-200 rounded mx-auto w-32"></div>
                </div>
              ) : (
                <>
                  <h3 className="text-4xl font-bold text-green-600 mb-3">
                    {stats.resolved.toLocaleString() || '0'}
                  </h3>
                  <p className="text-gray-700 font-semibold text-lg">
                    {t('home.successfullyResolved') || 'Successfully Resolved'}
                  </p>
                  <p className="text-gray-600 text-sm mt-1">
                    {t('home.complaintsClosed') || 'Complaints Closed'}
                  </p>
                </>
              )}
            </div>

            <div className="relative text-center p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border-2 border-blue-200 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
              {stats.loading ? (
                <div className="animate-pulse">
                  <div className="h-12 bg-gray-200 rounded mb-3 mx-auto w-16"></div>
                  <div className="h-4 bg-gray-200 rounded mx-auto w-24"></div>
                </div>
              ) : (
                <>
                  <h3 className="text-4xl font-bold text-blue-600 mb-3">
                    {stats.registered > 0
                      ? Math.round((stats.resolved / stats.registered) * 100)
                      : 0}
                    %
                  </h3>
                  <p className="text-gray-700 font-semibold text-lg">
                    {t('home.resolutionRate') || 'Resolution Rate'}
                  </p>
                  <p className="text-gray-600 text-sm mt-1">
                    {t('home.successPercentage') || 'Success Percentage'}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div> */}

      {/* How It Works Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div
          className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 sm:p-12 border border-white/20"
          style={{
            backgroundImage:
              'radial-gradient(circle at 50% 50%, rgba(99, 102, 241, 0.05) 0%, transparent 50%)',
          }}
        >
          <div className="text-center mb-12">
            <h3
              className={`text-xl sm:text-2xl font-bold text-gray-900 ${isMarathi ? 'mb-2' : 'mb-4'}`}
            >
              {t('home.process.title')}
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t('home.process.subtitle')}
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center process-step">
              <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <span
                  className="text-2xl font-bold"
                  style={{ color: '#B8860B' }}
                >
                  {t('home.process.title1') || 'Step 1'}
                </span>
              </div>
              <h4
                className={`text-xl font-bold text-gray-900 ${isMarathi ? 'mb-2' : 'mb-3'}`}
              >
                {t('home.process.step1.title')}
              </h4>
              <p
                className={`text-gray-600 leading-relaxed ${isMarathi ? 'mb-2' : ''}`}
              >
                {t('home.process.step1.description')}
              </p>
              <div
                className={`mt-4 w-full h-1 bg-gray-200 rounded ${isMarathi ? 'mt-6' : ''}`}
              >
                <div
                  className="w-full h-1 rounded"
                  style={{ backgroundColor: '#B8860B' }}
                ></div>
              </div>
            </div>

            <div className="text-center process-step">
              <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <span
                  className="text-2xl font-bold"
                  style={{ color: '#B8860B' }}
                >
                  {t('home.process.title2') || 'Step 2'}
                </span>
              </div>
              <h4
                className={`text-xl font-bold text-gray-900 ${isMarathi ? 'mb-2' : 'mb-3'}`}
              >
                {t('home.process.step2.title')}
              </h4>
              <p
                className={`text-gray-600 leading-relaxed ${isMarathi ? 'mb-2' : ''}`}
              >
                {t('home.process.step2.description')}
              </p>
              <div
                className={`mt-4 w-full h-1 bg-gray-200 rounded ${isMarathi ? 'mt-6' : ''}`}
              >
                <div
                  className="w-2/3 h-1 rounded"
                  style={{ backgroundColor: '#B8860B' }}
                ></div>
              </div>
            </div>

            <div className="text-center process-step">
              <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <span
                  className="text-2xl font-bold"
                  style={{ color: '#B8860B' }}
                >
                  {t('home.process.title3') || 'Step 3'}
                </span>
              </div>
              <h4
                className={`text-xl font-bold text-gray-900 ${isMarathi ? 'mb-2' : 'mb-3'}`}
              >
                {t('home.process.step3.title')}
              </h4>
              <p
                className={`text-gray-600 leading-relaxed ${isMarathi ? 'mb-2' : ''}`}
              >
                {t('home.process.step3.description')}
              </p>
              <div
                className={`mt-4 w-full h-1 bg-gray-200 rounded ${isMarathi ? 'mt-6' : ''}`}
              >
                <div
                  className="w-1/3 h-1 rounded"
                  style={{ backgroundColor: '#B8860B' }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact & Support Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 overflow-hidden">
          <div className="text-center py-8 px-6">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
              {t('home.contact.title') || 'Contact & Support'}
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              {t('home.contact.subtitle') ||
                'Get in touch with us for support or queries.'}
            </p>

           {/* Contact Methods Grid */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto px-4">
  {/* Phone Contact */}
  <div className="flex flex-col items-center p-6 bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl border-2 border-orange-200 hover:shadow-lg transition-all duration-300">
    <div
      className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
      style={{ backgroundColor: 'rgba(184, 134, 11, 0.1)' }}
    >
      <svg
        className="w-8 h-8"
        style={{ color: '#B8860B' }}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />
      </svg>
    </div>
    <h4 className="text-lg font-bold text-gray-900 mb-2">
      {t('home.contact.phone')}
    </h4>
    <p className="text-sm text-gray-600 mb-3">
      {t('home.contact.phoneDesc')}
    </p>
    <p className="font-semibold" style={{ color: '#B8860B' }}>
      {t('home.contact.phone') || '+91 12345 67890'}
    </p>
  </div>

  {/* WhatsApp Support */}
  <div className="flex flex-col items-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border-2 border-green-200 hover:shadow-lg transition-all duration-300">
    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
      <svg
        className="w-8 h-8 text-green-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.785" />
      </svg>
    </div>
    <h4 className="text-lg font-bold text-gray-900 mb-2">
      {t('home.contact.whatsapp')}
    </h4>
    <p className="text-sm text-gray-600 mb-3">
      {t('home.contact.whatsappDesc')}
    </p>
    <p className="text-xs text-gray-500 mt-2">
      {t('home.contact.whatsappNote')}
    </p>
  </div>
</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
